import React from 'react';
import { Menu, Button, Avatar, Dropdown, Space, Badge, message } from 'antd';
import { UserOutlined, HomeOutlined, FileTextOutlined, SettingOutlined, DatabaseOutlined, VideoCameraOutlined, PlayCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isAuthenticated } = useAuth();

  const role = user?.role || 'creator';

  // 从路径中提取项目ID
  const pathMatch = location.pathname.match(/project\/([^/]+)/);
  const projectId = pathMatch ? pathMatch[1] : null;

  // 检查是否在项目页面
  const isInProject = location.pathname.startsWith('/project/') && projectId;

  // 构建菜单项 - 在项目内时展开为平铺的标签页
  const getMenuItems = () => {
    const items = [];

    if (role !== 'admin') {
      items.push({
        key: '/',
        icon: <HomeOutlined />,
        label: <span onClick={() => navigate('/')}>首页</span>,
      });

      if (role === 'creator' && isInProject) {
        items.push({
          key: `/project/${projectId}`,
          icon: <FileTextOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}`)}>项目管理</span>,
        });

        items.push({
          key: `/project/${projectId}/script`,
          icon: <FileTextOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/script`)}>剧本创作</span>,
        });

        items.push({
          key: `/project/${projectId}/assets`,
          icon: <DatabaseOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/assets`)}>资产管理</span>,
        });

        items.push({
          key: `/project/${projectId}/storyboard`,
          icon: <VideoCameraOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/storyboard`)}>分镜生成</span>,
        });

        items.push({
          key: `/project/${projectId}/production`,
          icon: <PlayCircleOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/production`)}>视频制作</span>,
        });

        items.push({
          key: `/project/${projectId}/final-review`,
          icon: <CheckCircleOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/final-review`)}>成片审核</span>,
        });

        items.push({
          key: `/project/${projectId}/settings`,
          icon: <SettingOutlined />,
          label: <span onClick={() => navigate(`/project/${projectId}/settings`)}>项目设置</span>,
        });
      }
    }

    return items;
  };

  // 处理用户菜单点击
  const handleUserMenuClick = ({ key }) => {
    switch (key) {
      case 'profile':
        navigate('/profile');
        break;
      case 'transactions':
        navigate('/transactions');
        break;
      case 'recharge':
        navigate('/recharge');
        break;
      case 'admin':
        navigate('/admin');
        break;
      case 'logout':
        logout();
        navigate('/login');
        break;
      default:
        break;
    }
  };

  // 用户菜单项
  const userMenuItems = [];
  
  if (role !== 'admin') {
    userMenuItems.push(
      {
        key: 'profile',
        label: '个人中心',
      },
      {
        key: 'transactions',
        label: '交易记录',
      },
      {
        key: 'recharge',
        label: '充值积分',
      }
    );
  }
  
  
  
  userMenuItems.push(
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '退出登录',
    }
  );




  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%', padding: '0 24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        <span style={{ 
          color: '#00d4aa', 
          fontSize: '18px', 
          fontWeight: 'bold', 
          marginRight: '16px',
          textShadow: '0 0 10px rgba(0, 212, 170, 0.3)'
        }}>
          智影AI短剧创作系统
        </span>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={getMenuItems()}
          style={{ 
            background: 'transparent', 
            borderBottom: 'none', 
            flex: 1,
            whiteSpace: 'nowrap',
            fontSize: '13px'
          }}
          itemStyle={{
            marginRight: '8px',
            padding: '0 8px'
          }}
          overflowedIndicator={null}
          selectable={true}
        />
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {isAuthenticated ? (
          <Dropdown
            menu={{ items: userMenuItems, onClick: handleUserMenuClick }}
            placement="bottomRight"
          >
            <Space style={{ cursor: 'pointer', marginLeft: 16 }}>
              <Avatar icon={<UserOutlined />} src={user?.avatar} style={{ background: '#00d4aa' }} />
              <span style={{ color: '#e8e8ec' }}>{user?.nickname || user?.username}</span>
              <Badge 
                count={user?.points || 0} 
                style={{ backgroundColor: '#00d4aa', color: '#0d0d12', fontWeight: 'bold' }}
                overflowCount={99999}
              />
            </Space>
          </Dropdown>
        ) : (
          <Button type="primary" onClick={() => navigate('/login')}>
            登录
          </Button>
        )}
      </div>

    </div>
  );
};

export default Navigation;
